import React, { Component, Fragment } from "react";
import { TimelineItem } from ".";
import VerticalTimeline from "../VerticalTimeline/VerticalTimeline";
import { withGetScreen } from "react-getscreen";

/******************************************************************
*******************************************************************

HOW TO USE

const items = {
	activeColor: "#1abc9c",
	data: [
		{
			label: "<strong>Indicação<br />enviada</strong>",
			description: "15/02/1990 <br /> 12:12",
			className: "teste",
			active: true
		},
		{
			label: "<strong>Solicitação<br />de vínculo</strong>",
			description: "15/02/1990 <br /> 12:12",
			active: true
		},
		{
			label: "<strong>Vínculo<br />confirmado</strong>",
			description: "15/02/1990 <br /> 12:12",
			active: true,
			color: "danger",
			icon: "<i class='icon-close' style='color: white;'></i>"
		},
		{
			label: "<strong>Em análise na<br />MaxMilhas</strong>",
			description: "15/02/1990 <br /> 12:12",
			active: false
		},
		{
			label: "<strong>Vínculo<br />ativado</strong>",
			description: "15/02/1990 <br /> 12:12",
			active: false
		}
	]
};

<Timeline items={items} />

*******************************************************************
******************************************************************/

class Timeline extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	mountItems(config) {
		return config.data.map((item, idx) => {
			let nextItem = idx + 1;
			let borderActive = idx < config.data.length && config.data[idx].active;
			if (idx === 0) {
				return (
					<Fragment key={`item-${idx}`}>
						<TimelineItem className="timeline-item-component--half-item timeline-item-component--first-item" />
						<TimelineItem
							activeColor={config.activeColor}
							inactiveColor={config.inactiveColor}
							item={item}
							lengthMax={config.lengthMax}
							borderActive={borderActive}
							activeIcon={config.activeIcon}
							inactiveIcon={config.inactiveIcon}
						/>
					</Fragment>
				);
			} else if (config.data.length === nextItem) {
				return (
					<TimelineItem
						key={`item-${idx}`}
						activeColor={config.activeColor}
						inactiveColor={config.inactiveColor}
						item={item}
						lengthMax={config.lengthMax}
						borderActive={borderActive}
						activeIcon={config.activeIcon}
						inactiveIcon={config.inactiveIcon}
						lastItem={true}
						className="timeline-item-component--half-item timeline-item-component--last-item"
					/>
				);
			}

			return (
				<TimelineItem
					key={`item-${idx}`}
					activeColor={config.activeColor}
					inactiveColor={config.inactiveColor}
					item={item}
					lengthMax={config.lengthMax}
					borderActive={borderActive}
					activeIcon={config.activeIcon}
					inactiveIcon={config.inactiveIcon}
				/>
			);
		});
	}

	render() {
		const { className, config } = this.props;

		const style = ["timeline-component timeline-component__container", className].join(" ");

		return (
			<div className={style}>
				{this.props.isMobile() || this.props.isTablet() ? (
					<VerticalTimeline config={config} />
				) : (
					this.mountItems(config)
				)}
			</div>
		);
	}
}

export default withGetScreen(Timeline, {
	mobileLimit: 468,
	tabletLimit: 768,
	shouldListenOnResize: true
});
